<div class="container mt-5">
  <h2 class="text-primary mb-4">رخص ممارسة النشاط الاقتصادي</h2>
  <p>
    البحث
  </p>
  <!-- Search Form -->
  <form (ngSubmit)="onSearch()" class="mb-4">
    <div class="d-flex gap-2">
      <input type="text" class="form-control" placeholder="الرقم الوطني للمنشأة" [(ngModel)]="enterpriseNationalNumber"
        name="enterpriseNationalNumber" />

      <input type="text" class="form-control" placeholder="رقم الرخصة" [(ngModel)]="licenseNumber"
        name="licenseNumber" />

      <button type="submit" class="btn btn-primary" (click)="onSearch()">Search</button>
      <button class="btn btn-secondary" type="button" (click)="clearForm()">Clear</button>
    </div>
  </form>

  <!-- Reactive Form -->
  <hr>

  <form [formGroup]="activityForm" (ngSubmit)="save()">
    <div class="row g-3">
      <div class="col-md-4" *ngFor="let field of fields">
        <label class="form-label">{{ field.label }}</label>

        @if(field?.controlType=='Select'){

        <select class="form-control" [formControlName]="field.control" [class.is-invalid]="
              activityForm.get(field.control)?.touched &&
              activityForm.get(field.control)?.invalid
            ">
          @for (item of field.options; track $index) {
          <option value="{{item}}">{{item}}</option>
          }
        </select>


        }@else {

        <input type="{{field.controlType=='Date'?'date':'text'}}" class="form-control" [formControlName]="field.control"
          [class.is-invalid]="
              activityForm.get(field.control)?.touched &&
              activityForm.get(field.control)?.invalid
            " />

        }

        <div class="invalid-feedback" *ngIf="
            activityForm.get(field.control)?.touched &&
            activityForm.get(field.control)?.invalid
          ">
          هذا الحقل مطلوب / This field is required
        </div>
      </div>
    </div>

    <div class="mt-4 text-end">
      <button type="submit" class="btn btn-primary">
        حفظ
      </button>
    </div>
  </form>
</div>


<br>
<br>
<br>
<br>